import { http } from 'vue'

const RESOURCE = 'judicial_lawsuit_queries'

const messageFromError = (error, fallback) => {
  const data = (error && error.data) || {}
  if (data.message) return data.message
  if (data.errors) {
    const first = Object.keys(data.errors)[0]
    if (first) return [].concat(data.errors[first])[0]
  }
  return fallback
}

const onlyFilled = (params) => {
  return Object.keys(params).reduce((filled, key) => {
    const value = params[key]
    if (value !== '' && value !== null && value !== undefined && value !== false) filled[key] = value
    return filled
  }, {})
}

export default {
  async fetchJudicialLawsuitQuery ({ commit }, clientId) {
    commit('SET_LOADING_JUDICIAL_LAWSUIT_QUERY', true)
    commit('SET_JUDICIAL_LAWSUIT_ERROR', null)
    try {
      const response = await http.get(RESOURCE, { params: { client_id: clientId } })
      commit('SET_JUDICIAL_LAWSUIT_QUERY', response.data.data || null)
      return response.data.data || null
    } catch (error) {
      commit('SET_JUDICIAL_LAWSUIT_ERROR', messageFromError(error, 'Erro ao buscar a consulta de processos judiciais.'))
      return null
    } finally {
      commit('SET_LOADING_JUDICIAL_LAWSUIT_QUERY', false)
    }
  },
  async createJudicialLawsuitQuery ({ commit }, clientId) {
    commit('SET_CREATING_JUDICIAL_LAWSUIT_QUERY', true)
    commit('SET_JUDICIAL_LAWSUIT_ERROR', null)
    try {
      const response = await http.post(RESOURCE, { client_id: clientId })
      commit('SET_JUDICIAL_LAWSUIT_QUERY', response.data.data)
      commit('SET_JUDICIAL_LAWSUITS', [])
      commit('SET_JUDICIAL_LAWSUITS_PAGINATION', null)
      return response.data.data
    } catch (error) {
      commit('SET_JUDICIAL_LAWSUIT_ERROR', messageFromError(error, 'Não foi possível iniciar a consulta de processos judiciais.'))
      return null
    } finally {
      commit('SET_CREATING_JUDICIAL_LAWSUIT_QUERY', false)
    }
  },
  async fetchJudicialLawsuits ({ commit }, { queryId, params = {} }) {
    commit('SET_LOADING_JUDICIAL_LAWSUITS', true)
    commit('SET_JUDICIAL_LAWSUIT_ERROR', null)
    try {
      const response = await http.get(`${RESOURCE}/${queryId}/lawsuits`, { params: onlyFilled(params) })
      const { data, ...pagination } = response.data
      commit('SET_JUDICIAL_LAWSUITS', data)
      commit('SET_JUDICIAL_LAWSUITS_PAGINATION', pagination)
      return data
    } catch (error) {
      commit('SET_JUDICIAL_LAWSUITS', [])
      commit('SET_JUDICIAL_LAWSUITS_PAGINATION', null)
      commit('SET_JUDICIAL_LAWSUIT_ERROR', messageFromError(error, 'Erro ao buscar a lista de processos judiciais.'))
      return []
    } finally {
      commit('SET_LOADING_JUDICIAL_LAWSUITS', false)
    }
  },
  async fetchJudicialLawsuitDetail ({ commit }, lawsuitId) {
    commit('SET_LOADING_JUDICIAL_LAWSUIT_DETAIL', true)
    commit('SET_JUDICIAL_LAWSUIT_DETAIL', null)
    commit('SET_JUDICIAL_LAWSUIT_ERROR', null)
    try {
      const response = await http.get(`judicial_lawsuits/${lawsuitId}`)
      commit('SET_JUDICIAL_LAWSUIT_DETAIL', response.data.data)
      return response.data.data
    } catch (error) {
      commit('SET_JUDICIAL_LAWSUIT_ERROR', messageFromError(error, 'Erro ao buscar os detalhes do processo.'))
      return null
    } finally {
      commit('SET_LOADING_JUDICIAL_LAWSUIT_DETAIL', false)
    }
  },
  clearJudicialLawsuitDetail ({ commit }) {
    commit('SET_JUDICIAL_LAWSUIT_DETAIL', null)
  },
  clearJudicialLawsuits ({ commit }) {
    commit('CLEAR_JUDICIAL_LAWSUITS')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/judicial_lawsuits/actions.js